// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"16855": "large-vendor.shikijs-3","31180": "large-vendor.excalidraw-a98276e3","33712": "echarts","40560": "large-vendor.shikijs-2","50970": "super-integration","54110": "large-vendor.excalidraw-5d4b5418","54777": "monaco-editor","69990": "super-pricing","72154": "large-vendor.shikijs-0","81697": "large-vendor.shikijs-1","90231": "super-editor","98503": "large-vendor.excalidraw-2",}[chunkId] || chunkId) + ".bundle.js"
}